import React, { FunctionComponent } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Grid, Image } from 'semantic-ui-react';
import withStyles from 'react-jss';

import MainNav from './components/Navigation';
import SecondaryNav from './components/SecondaryNav';
import SubHeader from './components/SubHeader';
import Filters from './components/Filters';
import logo from 'assets/icons/nav-logo-purple.svg';
import styles from './Header.styles';

import { ClassProp } from 'helpers/types';

type Props = {
  classes: ClassProp<typeof styles>;
};

const Header: FunctionComponent<Props> = ({ classes }) => (
  <Grid className={classes.header}>
    <Grid.Row className={classes.container}>
      <div className={classes.logo}>
        <Image src={logo} />
      </div>
      <MainNav />
      <SecondaryNav />
    </Grid.Row>
    <hr className={classes.break} />
    <Grid.Row className={classes.subHeader}>
      <SubHeader />
    </Grid.Row>
    <Switch>
      <Route
        exact
        component={Filters}
        path={[
          '/merchant/:merchantId/overview/:merchantName',
          '/:merchantName/overview',
        ]}
      />
    </Switch>
  </Grid>
);

export default withStyles(styles)(Header);
